module.exports = __webpack_public_path__ + "media/assets/images/tour/1_Tour_4-0abd7a06e230ae5a1ba6371cc6bf23f9.png";